import { styled } from 'styled-components';

export const Dl = styled.dl`
  margin: 0;
`;
